module.exports = __webpack_public_path__ + "img/device004.44bef643.png";